import {
    SubscriptionCreateForm,
    SubscriptionUpdateForm,
    SubscriptionData,
    SubscriptionQuery,
    SubscriptionListResponse,
    type SubscriptionOverLimitRenderedServicesResponse,
} from 'chaika-frontend-types/frontend-cms';

import { axios } from '@lib/axios';

const BASE_URL = '/api';

export class SubscriptionApi {
    public static async create(ehrId: string, subscription: SubscriptionCreateForm): Promise<void> {
        await axios.post(`${BASE_URL}/ehr/${ehrId}/subscription`, { subscription });
    }

    public static async update(
        ehrId: string,
        subscriptionId: string,
        subscription: SubscriptionUpdateForm,
    ): Promise<void> {
        await axios.put(`${BASE_URL}/ehr/${ehrId}/subscription/${subscriptionId}`, { subscription });
    }

    public static async getList(ehrId: string, params?: SubscriptionQuery): Promise<SubscriptionData[]> {
        const res = await axios.get<SubscriptionListResponse>(`${BASE_URL}/ehr/${ehrId}/subscription`, { params });

        return res.data.subscriptions;
    }

    public static async find(params: SubscriptionQuery): Promise<SubscriptionData[]> {
        const res = await axios.get<SubscriptionListResponse>(`${BASE_URL}/subscription`, { params });

        return res.data.subscriptions;
    }

    public static async getOverLimitRenderedServiceIds(subscriptionId: string): Promise<string[]> {
        const res = await axios.get<SubscriptionOverLimitRenderedServicesResponse>(
            `${BASE_URL}/subscription/${subscriptionId}/rendered-services-over-limit`,
        );

        return res.data.renderedServiceIds;
    }
}
